import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MaskedInput from 'react-input-mask';
import style from './style.scss';

const Input = ({
  className = '',
  labelClassName = '',
  notification = '',
  isZipcode = false,
  isMasked = '',
  isBadgeVisible = true,
  errorMessage = '',
  label = null,
  placeHolder = '',
  value = '',
  hasError = false,
  isDisabled = false,
  isRequired = false,
  type = 'text',
  onChange = () => {},
  max = 0,
  ...restProps
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isRequiredState, setIsRequiredState] = useState(false);
  const [isNotificationShowing, setIsNotificationShowing] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    if (e.target.value) {
      setIsRequiredState(true);
    } else {
      setIsRequiredState(isRequired);
    }
    !isRequired && setIsFocused(false);
  };

  const handleMouseEnter = () => {
    setIsNotificationShowing(true);
  };

  const handleMouseLeave = () => {
    setIsNotificationShowing(false);
  };

  const valueLength = (value || '').length;
  return (
    <label className={cn({ 'has-value': isFocused || valueLength || isDisabled || hasError, required: isRequiredState || hasError }, labelClassName)}>
      <span className={style.span}>
        {label} {
            isBadgeVisible && !isDisabled &&
            <em>
              {isRequired && errorMessage === 'The input field is required' && 'Required'}
              {isRequired && errorMessage !== 'The input field is required' && hasError && 'Error'}
              {!isRequired && errorMessage !== 'The input field is required' && hasError && 'Error'}
              {isRequired && !hasError && 'Required'}
              {!isRequired && !hasError && 'Optional'}
            </em>
          }
      </span>
      {
          isMasked ?
            <MaskedInput
              className={cn(className, style.input)}
              value={value || ''}
              mask={isMasked}
              disabled={isDisabled}
              placeholder={(isFocused || valueLength || isDisabled || hasError) ? placeHolder : ''}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onChange={onChange}
              type={type}
              max={max}
              {...restProps}
            />
          :
            <input
              className={cn(className, style.input)}
              value={value || ''}
              disabled={isDisabled}
              placeholder={(isFocused || valueLength || isDisabled || hasError) ? placeHolder : ''}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onChange={onChange}
              type={type}
              max={max}
              {...restProps}
            />
        }
      {
          notification &&
          <div className={cn(style.tooltip, isNotificationShowing && style.active)}>
            <i
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >i
            </i>
            <div>{notification}</div>
          </div>
        }
      <div className={style.error}>{errorMessage !== 'The input field is required' && errorMessage}</div>
    </label>
  );
};

Input.propTypes = {
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  value: PropTypes.string,
  max: PropTypes.number,
  isDisabled: PropTypes.bool,
  label: PropTypes.node,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  isBadgeVisible: PropTypes.bool,
  placeHolder: PropTypes.string,
  isMasked: PropTypes.string,
  notification: PropTypes.string,
  isZipcode: PropTypes.bool,
};

export default Input;
